module.exports = __webpack_public_path__ + "img/visa.4ab9900e.svg";